import { render, staticRenderFns } from "./PayCreate.vue?vue&type=template&id=1237dac0"
import script from "./PayCreate.vue?vue&type=script&lang=js"
export * from "./PayCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports